/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OWGameResponse } from './OWGameResponse';
import {
    OWGameResponseFromJSON,
    OWGameResponseFromJSONTyped,
    OWGameResponseToJSON,
    OWGameResponseToJSONTyped,
} from './OWGameResponse';

/**
 * 
 * @export
 * @interface PopularQuestGame
 */
export interface PopularQuestGame {
    /**
     * 
     * @type {OWGameResponse}
     * @memberof PopularQuestGame
     */
    game?: OWGameResponse;
    /**
     * Total minutes played by all users
     * @type {number}
     * @memberof PopularQuestGame
     */
    totalTimePlayed?: number;
    /**
     * Number of unique players
     * @type {number}
     * @memberof PopularQuestGame
     */
    uniquePlayers?: number;
}

/**
 * Check if a given object implements the PopularQuestGame interface.
 */
export function instanceOfPopularQuestGame(value: object): value is PopularQuestGame {
    return true;
}

export function PopularQuestGameFromJSON(json: any): PopularQuestGame {
    return PopularQuestGameFromJSONTyped(json, false);
}

export function PopularQuestGameFromJSONTyped(json: any, ignoreDiscriminator: boolean): PopularQuestGame {
    if (json == null) {
        return json;
    }
    return {
        
        'game': json['game'] == null ? undefined : OWGameResponseFromJSON(json['game']),
        'totalTimePlayed': json['totalTimePlayed'] == null ? undefined : json['totalTimePlayed'],
        'uniquePlayers': json['uniquePlayers'] == null ? undefined : json['uniquePlayers'],
    };
}

export function PopularQuestGameToJSON(json: any): PopularQuestGame {
    return PopularQuestGameToJSONTyped(json, false);
}

export function PopularQuestGameToJSONTyped(value?: PopularQuestGame | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'game': OWGameResponseToJSON(value['game']),
        'totalTimePlayed': value['totalTimePlayed'],
        'uniquePlayers': value['uniquePlayers'],
    };
}

